import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';
import { investmentPage } from '../../data/mock';
import { TrendingUp, ChevronRight } from 'lucide-react';
import AnimateOnScroll from '../../components/AnimateOnScroll';
import Footer from '../../components/layout/Footer';

const Investment = () => {
  const { language } = useLanguage();
  const content = investmentPage[language];

  return (
    <div className="min-h-screen relative">
      {/* Background */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url('https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=1920&q=80')`,
        }}
      >
        <div className="absolute inset-0 bg-[#1a2a3a]/85" />
      </div>

      {/* Content */}
      <div className="relative z-10 min-h-screen flex flex-col items-center px-4 sm:px-6 pt-24 sm:pt-32 pb-20 sm:pb-24">
        <AnimateOnScroll animation="fadeIn">
          <div className="mb-6 sm:mb-8">
            <TrendingUp className="text-[#3eb8b3]" size={48} strokeWidth={1} />
          </div>
        </AnimateOnScroll>

        <AnimateOnScroll animation="fadeInUp" delay={100}>
          <h1 className="text-white text-3xl sm:text-4xl md:text-5xl font-light mb-6 sm:mb-8 text-center">
            {content.title}
          </h1>
        </AnimateOnScroll>

        <AnimateOnScroll animation="fadeInUp" delay={200}>
          <p className="text-white/80 text-base sm:text-xl text-center max-w-3xl mb-8 sm:mb-12 leading-relaxed">
            {content.intro}
          </p>
        </AnimateOnScroll>

        <div className="max-w-4xl w-full space-y-4 sm:space-y-6 mb-12 sm:mb-16">
          {content.points.map((point, index) => (
            <AnimateOnScroll key={index} animation="fadeInUp" delay={300 + index * 100}>
              <div className="flex items-start gap-3 sm:gap-4 text-white/80 text-base sm:text-lg leading-relaxed">
                <ChevronRight className="text-[#3eb8b3] shrink-0 mt-1" size={18} />
                <p>{point}</p>
              </div>
            </AnimateOnScroll>
          ))}
        </div>

        {/* Graph */}
        <AnimateOnScroll animation="scaleIn" delay={400} className="max-w-4xl w-full mb-8 sm:mb-12">
          <div className="bg-white/5 backdrop-blur-sm rounded-lg p-4 sm:p-8 border border-white/10">
            <div className="h-36 sm:h-48 flex items-center justify-center">
              <div className="flex items-end gap-2 sm:gap-4 h-full w-full max-w-md justify-center">
                {[40, 60, 45, 80, 55, 90, 70, 95, 85, 100].map((height, i) => (
                  <div
                    key={i}
                    className="flex-1 max-w-10 bg-gradient-to-t from-[#3eb8b3] to-[#3eb8b3]/50 rounded-t transition-all hover:from-[#2ea09b] hover:to-[#2ea09b]/50"
                    style={{ height: `${height}%` }}
                  />
                ))}
              </div>
            </div>
          </div>
        </AnimateOnScroll>

        <Link
          to="/contacto"
          className="hover-glow bg-[#3eb8b3] text-white px-6 sm:px-8 py-3 sm:py-4 text-base sm:text-lg tracking-wider hover:bg-[#2ea09b] transition-colors"
        >
          {content.cta}
        </Link>
      </div>

      <Footer />
    </div>
  );
};

export default Investment;
